<button
  type="button"
  class="sp-dd__trigger"
  [class.sp-dd__trigger--open]="open"
  [class.sp-dd__trigger--invalid]="invalid"
  [class.sp-dd__trigger--placeholder]="!selectedLabel"
  [disabled]="disabled"
  (click)="toggle()">
  <span class="sp-dd__value">{{ selectedLabel || placeholder }}</span>
  <svg class="sp-dd__chevron" [class.sp-dd__chevron--open]="open"
       width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 3.5l3 3 3-3" stroke="currentColor" stroke-width="1.4"
          stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>

<div class="sp-dd__panel" *ngIf="open">

  <div class="sp-dd__search" *ngIf="searchable">
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <circle cx="5.5" cy="5.5" r="4" stroke="#9CA3AF" stroke-width="1.2"/>
      <path d="M8.5 8.5L11 11" stroke="#9CA3AF" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
    <input type="text" [placeholder]="searchPlaceholder" [(ngModel)]="searchTerm" autocomplete="off"/>
  </div>

  <div class="sp-dd__options">
    <button
      type="button"
      class="sp-dd__option"
      *ngFor="let opt of filteredOptions"
      [class.sp-dd__option--selected]="opt.value === value"
      (click)="select(opt)">
      <span>{{ opt.label }}</span>
      <svg *ngIf="opt.value === value" class="sp-dd__check"
           width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M2 7.5l3.2 3.2L12 4" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="sp-dd__empty" *ngIf="!filteredOptions.length">No matches</div>
  </div>

</div>

<!-- Click-away catcher (matches trend-filters backdrop pattern) -->
<div class="sp-dd__backdrop" *ngIf="open" (click)="close()"></div>
